export const environment = {
  production: false,
  apiUrl: 'https://taxora-backend-dev.onrender.com',
  appName: 'Taxora Business',
  version: '1.0.0',
};
